/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Answer from 'material/embeds/embed/shared/answer/answer_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/shared/answerset/answerset_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER SET : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AnswerSet extends Component {
    _renderAnswers() {
        const options = [];
        for (let optionId of Object.keys(this.props.currentContentStatus.questionBased.options)) {
            options.push(<Answer key={optionId} contentId={this.props.contentId} optionId={optionId} type={this.props.currentContentStatus.questionBased.type} isEditable={this.props.isEditable} />)
        }
        return options;
    }
    render() {
        // const numberOfOptions = Object.keys(this.props.currentContentStatus.options).length;
        return(
            <div className={`answerset ${this.props.classes.answerset} ${this.props.currentContentStatus.questionBased.type} answeramount-${this.props.numberOfOptions}`}>
                {this._renderAnswers()}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(AnswerSet);
